module.exports = __webpack_public_path__ + "img/fu0003.4284b85f.webp";